import { render } from "./DisenoCurricular.vue?vue&type=template&id=2a8f224c&scoped=true"
import script from "./DisenoCurricular.vue?vue&type=script&lang=js"
export * from "./DisenoCurricular.vue?vue&type=script&lang=js"

import "./DisenoCurricular.vue?vue&type=style&index=0&id=2a8f224c&scoped=true&lang=css"

import exportComponent from "/Users/fasa/JS/freelance/UgaldeYAsociados/gerardoyasociados-website-final/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a8f224c"]])

export default __exports__